import eventBus from '../eventBus'
import { IMedia } from '../../shared/MediaPreview/mediaPreview.types.ts'

const requestMediaPreview = (medias: IMedia[], index: number = 0, loader: React.ReactNode = null) => {
  eventBus.pub('mediaPreview.request', { medias, index, loader }) //to open the modal
}

const mediaPreviewService = { requestMediaPreview }
export default mediaPreviewService
